module.exports = __webpack_public_path__ + "img/info.8d7c4962.png";